module.exports = __webpack_public_path__ + "img/iconic-content-2.ac435e37.svg";